import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import * as React from "react";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import {
  Container,
  Dropdown,
  Accordion,
  Card,
  Button,
  Form,
  Spinner,
  Modal,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import DepositSlideout from "../Transaction/DepositSlideout";
import WithdrawalSlideout from "../Transaction/WithdrawalSlideout";
import TransferSlideout from "../Transaction/TransferSlideout";
import { ToastContainer, toast } from "react-toastify";
import { VendorService } from "../../Common/Services/VendorService";
import { InvoiceService } from "../../Common/Services/InvoiceService";
import Customerorderslideout from "../Customerorderslideout";
import { Utils } from "../../Common/Utilis";
import BankSyncModal from "./BankSyncModal";
import _ from "lodash";
import paginationFactory from "react-bootstrap-table2-paginator";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import createDOMPurify from "dompurify";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
//import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import InvoiceEntryslideout from "../Purchasing/InvoiceEntryslideout";
import Vendororderslideout from "../Vendororderslideout";
import InvoiceSlideout from "../Transaction/InvoiceSlideout";
import ImportInvoice from "./ImportInvoice";
import { TransactionService } from "../../Common/Services/TransactionService";
import DatePicker from "react-datepicker";
import { FaSortAmountDown } from "react-icons/fa";
import { IoRecordingSharp } from "react-icons/io5";
import Invoice from "./Invoice";

const { SearchBar } = Search;

const DOMPurify = createDOMPurify(window);
let storage = JSON.parse(localStorage.getItem("storage")!);
let currentUtcTime =
  storage === null ? "America/Chicago" : (storage.currentUtcTime as any);
const formattedDate = Utils.convertUtcToTimezoneFormat(
  new Date(),
  currentUtcTime
);

export class BankSync extends React.Component<any, any> {
  private trDate: any;
  constructor(props: any) {
    super(props);
    this.bindfilter = this.bindfilter.bind(this);
    // const { bankId } = this.props.location.state || {};
    const bankId = parseInt(localStorage.getItem("selectedBankId") || "0", 10);
    this.state = {
      activeKey: "first",
      transactionId: 0,
      adjData: {},
      adjDetails: {},
      lastUploadText: "",
      showPopup: false,
      footershow2: false,
      selectedRows2: [],
      selectedReviewId: 0,
      slideoutAmount: 0,
      slideoutDate: null,
      slideutId: 0,
      searchedData: [],
      searchQuery: "",
      expandedRows: [],
      footershow: false,
      selectedRows: [],
      selectedRows1: [],
      selectedRowscustomerid: [],
      bankList: [],
      invoiceTotal: 0,
      isstatus: true,
      isorderdate: true,
      iscustomername: true,
      iscustomercode: true,
      iscustomerpo: true,
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      customerOrderResult: [],
      customerOriginalOrderResult: [],
      invoiceList: [],
      invoiceId: 0,
      orderIds: [],
      itemsIds: [],
      selectedcolumn: "+/- 1 Day",
      selectedid: 1,
      selectOptions: [
        {
          id: 0,
          name: "All Transactions",
        },
        {
          id: 1,
          name: "+/- 1 Day",
        },
        { id: 3, name: "+/- 3 Day" },
        { id: 5, name: "+/- 5 Day" },
        { id: 10, name: "+/- 10 Day" },
        { id: 30, name: "+/- 30 Day" },
      ],
      formData: {
        bankId: bankId,
      },
      bankname: "Select",
    };
  }

  componentDidMount() {
    this.getbankList();
    this.GetadjCoa();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId) {
      const { formData } = this.state;
      formData.bankId = 0;
      this.setState({ formData }, () => {
        this.getbankList();
      });
    }
  }

  GetadjCoa = () => {
    TransactionService.GetadjCoa({})
      .then(async (result: any | null) => {
        if (result != null) {
          this.setState({ adjDetails: result });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  LastUpload = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      TransactionService.LastUpload({})
        .then((result: any | null) => {
          let displayText = "";

          if (result?.createdAt) {
            const m = moment(result.createdAt);
            if (m.isValid()) {
              displayText = `Last manual upload was on ${m.format(
                "MM/DD/YYYY"
              )} `;
              // on ${m.format("h:mm")}
            }
          }

          this.setState({ lastUploadText: displayText });
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });
    });
  };

  getBankSyncAll = () => {
    TransactionService.getBankSyncAll({
      bankid: this.state.formData.bankId,
      day: this.state.selectedid,
      type: this.state.maintype == "Deposit" ? "D" : "W",
    })
      .then(async (result: any | null) => {
        if (result != null) {
          this.setState({ searchedData: [] }, () => {
            this.setState({ searchedData: result, selectedRows1: [] }, () =>
              resolve()
            );
          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  getbankList = () => {
    let requestlist = { ...this.state.requestlist };
    InvoiceService.GetBankMaster(requestlist)
      .then(async (result: any | null) => {
        if (result != null) {
          let tempBankList: any = [];
          result.forEach((element) => {
            tempBankList.push({
              id: element.id,
              name: element.nickName + "-" + element.lastAccountNo.slice(-4),
              isShared: !!element.sharingid,
              isprimary: element.isprimary,
            });
          });

          this.setState({ bankList: [] }, () => {
            this.setState({ bankList: tempBankList });
            const { formData } = this.state;

            // let selectedBankId = formData.bankId
            //   ? formData.bankId
            //   : tempBankList.length > 0
            //   ? tempBankList[0].id
            //   : 0;
            const selectedBankId =
              formData.bankId ||
              tempBankList.find((b) => b.isprimary)?.id ||
              tempBankList[0]?.id ||
              0;

            formData.bankId = selectedBankId;             
            let selectedBank = tempBankList.find(
              (x) => x.id === selectedBankId
            );
            let bankname = selectedBank ? selectedBank.name : "";
            // formData.bankId = bankname
            //   ? selectedBankId
            //   : tempBankList[0].id || 0;

              formData.bankId = bankname ? selectedBankId : tempBankList?.[0]?.id || 0;


            localStorage.setItem('selectedBankId', formData.bankId);
            this.getVOItems(formData.bankId);
            // this.getBankSyncAll(formData.bankId);

            this.setState({ bankname, formData });
          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  getVOItems = (id: any) => {
    TransactionService.GetBankSync({ bankid: id })
      .then(async (result: any | null) => {
        if (result != null) {
          const updatedResult = result.map((item: any) => ({
            ...item,
            isExpanded: false,
          }));

          this.setState(
            {
              customerOrderResult: updatedResult,
              selectedRows: [],
              selectedRows1: [],
              selectedRows2: [],
              selectedReviewId: 0,
              slideoutAmount: 0,
              slideoutId: 0,
              slideoutDate: null,
              invoiceTotal: 0,
              footershow: false,
              footershow2: false,
              selectedcolumn: "+/- 1 Day",
              selectedid: 1,
            },
            () => {
              // this.getBankSyncAll(this.state.formData.bankId);
              this.LastUpload();
              this.bindfilter();
            }
          );
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  handleSelect = (key: string | null) => {
    this.setState((prevState) => ({
      footershow: false,
      invoiceTotal: 0,
      selectedRows: [],
      itemsIds: [],
      customerOrderResult: this.state.customerOriginalOrderResult,
      selectedCount: 0,
      invoiceList: this.state.originalinvoiceList,
    }));
  };

  handleAdjChange = (fieldName, value) => {
    this.setState((prevState) => ({
      adjData: {
        ...prevState.adjData,
        [fieldName]: value,
      },
    }));
  };

  redirectToReconciliation = () => {
    this.props.history.push({
      pathname: "/Reconcile",
      state: {
        bankId: this.state.formData.bankId,
        bankName: this.state.bankname,
        fromBankSync: true,
      },
    });
  };

  reconcileData = (type: any, mainid: any) => {
    const {
      selectedReviewId,
      selectedRows1,
      formData,
      customerOrderResult,
      searchedData,
      adjDetails,
    } = this.state;
    let matchedentries: any[] = [];
    let parentid = 0;
    if (type === "single") {
      const matchedRow = customerOrderResult.find(
        (x: any) => x.uniqueid == selectedReviewId
      );

      if (!matchedRow || !matchedRow.id) {
        toast.error("Select record to reconcile.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        return;
      }
      const recordDate = new Date(matchedRow.date);
      const parentDate = new Date(matchedRow.parentdate);

      const recordYear = recordDate.getFullYear();
      const recordMonth = recordDate.getMonth();
      const parentYear = parentDate.getFullYear();
      const parentMonth = parentDate.getMonth();

      if (
        recordYear > parentYear ||
        (recordYear === parentYear && recordMonth > parentMonth)
      ) {
        toast.error(
          `Unable to reconcile as this is a future dated transaction.`,
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          }
        );
        return;
      }

      matchedentries = [
        {
          id: matchedRow.id,
          banksyncId: matchedRow.parentid,
          date: matchedRow.parentdate,
          type: matchedRow.etype,
        },
      ];
      parentid = matchedRow.parentid;
    } else {
      const mainRecord = customerOrderResult.find(
        (x: any) => x.uniqueid == mainid
      );
      parentid = mainRecord.id;
      const mainDate = new Date(mainRecord.date);
      const totalAmount = parseFloat(mainRecord.amount);
      const matchedRecords = searchedData.filter((x: any) =>
        selectedRows1.includes(x.uniqueid)
      );

      let selectedAmountSum = 0;
      const organizedMatchedEntries: any[] = [];
      const mainYear = mainDate.getFullYear();
      const mainMonth = mainDate.getMonth();

      for (const rec of matchedRecords) {
        const recDate = new Date(rec.paydate);
        const recYear = recDate.getFullYear();
        const recMonth = recDate.getMonth();

        if (
          recYear > mainYear ||
          (recYear === mainYear && recMonth > mainMonth)
        ) {
          toast.error(
            `Unable to reconcile as this is a future dated transaction.`,
            { position: toast.POSITION.BOTTOM_RIGHT }
          );
          return;
        }

        selectedAmountSum += parseFloat(rec.amount || "0");
        organizedMatchedEntries.push({
          id: rec.id,
          type: rec.etype2,
          banksyncId: parentid,
          date: mainDate,
        });
      }

      const variance = parseFloat((totalAmount - selectedAmountSum).toFixed(2));
      if (variance !== 0) {
        this.setState({
          adjData: {
            variance: variance,
            description: "",
            date: mainRecord.date || new Date(),
            coaid: adjDetails.id,
            coa: adjDetails.coa,
            location: matchedRecords[0].location || "",
            locationid: matchedRecords[0].locationId,
            matched: organizedMatchedEntries
              .map((entry: any) => entry.id)
              .join(","),
          },
          showPopup1: true,
          matchedEntry: organizedMatchedEntries,
        });
        return;
      } else {
        matchedentries = organizedMatchedEntries;
      }
    }

    if (matchedentries.length === 0) {
      toast.error("Select record to reconcile.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      return;
    }
    // return;
    this.setState({ isSaveSpinner: true });

    TransactionService.ReconcileBankSync({
      bankid: this.state.formData.bankId,
      matchedentries,
    })
      .then((result: any | null) => {
        if (result !== null) {
          toast.success("Records Reconciled successfully.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });

          if (parentid > 0) {
            TransactionService.UpdateReconcileBankSync({ id: parentid }).then(
              (result: any | null) => {
                this.getVOItems(formData.bankId);
              }
            );
          }
          // else {
          //   this.getBankSyncAll();
          // }

          this.setState({ footershow: false });
        }
      })
      .catch((error) => {
        toast.error("Reconciliation failed.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        console.error("Reconcile error:", error);
        this.setState({ isdefaultColDisabled: false });
      })
      .finally(() => {
        this.setState({ isSaveSpinner: false });
      });
  };

  save = () => {
    const { adjData, matchedEntry, formData } = this.state;
    // let matchedentries: any[] = [];

    // if (matchedentries.length === 0) {
    //   toast.error("Select record to reconcile.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });
    //   return;
    // }
    // return;
    this.setState({ isSaveSpinner: true });

    TransactionService.ReconcileBankSync({
      bankid: this.state.formData.bankId,
      matchedentries: matchedEntry,
      adjData: [adjData],
    })
      .then((result: any | null) => {
        if (result !== null) {
          toast.success("Records Reconciled successfully.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });

          // this.getBankSyncAll();
          if (matchedEntry[0].banksyncId > 0) {
            TransactionService.UpdateReconcileBankSync({
              id: matchedEntry[0].banksyncId,
            }).then((result: any | null) => {
              this.getVOItems(formData.bankId);
            });
          }

          this.setState({ footershow: false, showPopup1: false });
        }
      })
      .catch((error) => {
        toast.error("Reconciliation failed.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
        console.error("Reconcile error:", error);
        this.setState({ isdefaultColDisabled: false });
      })
      .finally(() => {
        this.setState({ isSaveSpinner: false });
      });
  };

  excludeRecord = () => {
    this.setState({ isSaveSpinner: true });
    let isFormValid = false;

    isFormValid = true;

    if (isFormValid) {
      TransactionService.ExcludeRecords({ ids: this.state.selectedRows })
        .then(async (result: any | null) => {
          if (result !== null) {
            this.setState({ isSaveSpinner: false });
            toast.success("Records Excluded Successfully.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.getVOItems(this.state.formData.bankId);
            this.setState({ footershow: false });
          }
          this.setState({ isSaveSpinner: false });
          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          reject();
        });
    }
  };

  includeRecord = () => {
    this.setState({ isSaveSpinner: true });
    let isFormValid = false;

    isFormValid = true;

    if (isFormValid) {
      TransactionService.IncludeRecords({ ids: this.state.selectedRows2 })
        .then(async (result: any | null) => {
          if (result !== null) {
            this.setState({ isSaveSpinner: false });
            toast.success("Records Included Successfully.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.getVOItems(this.state.formData.bankId);
            this.setState({ footershow2: false });
          }
          this.setState({ isSaveSpinner: false });
          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          reject();
        });
    }
  };
  shownewslideout = () => {
    this.setState({ showSlideout: true, orderid: 0, isSpinner: false });
  };

  showslideout = () => {
    this.setState({ showSlideout: true, isSpinner: false });
  };
  closeVendorSlideOut = () => {
    this.setState({ showVendorSlideout: false, isSpinner: false });
  };

  discard = () => {
    let customerOrderResult = this.state.customerOrderResult;
    customerOrderResult.forEach((element) => {
      if (element.status == "review") element.selected = false;
    });

    this.setState({
      customerOrderResult: customerOrderResult,
      footershow: false,
      invoiceTotal: 0,
      selectedRows: [],
      selectedRowscustomerid: [],
    });
  };

  showBankslideout = (row) => {
    this.setState({
      showPopup: true,
    });
  };

  closeModal = () => {
    this.setState({ showPopup: false });
  };

  discard2 = () => {
    let customerOrderResult = this.state.customerOrderResult;
    customerOrderResult.forEach((element) => {
      if (element.status == "excluded") element.selected = false;
    });

    this.setState({
      customerOrderResult: customerOrderResult,
      footershow2: false,
      selectedRows2: [],
    });
  };

  showInvoiceslideout = (row) => {
    this.setState({
      showInvoice: true,
      footershow: false,
      transactionId: 0,
      isSpinner: false,
      invoiceTotal: 0,
      selectedRows: [],
      selectedRowscustomerid: [],
    });
  };

  showPopup = () => {
    this.setState({
      showPopup: true,
    });
  };

  closeModal1 = () => {
    this.setState({ showPopup: false }, () => {
      this.getVOItems(this.state.formData.bankId);
    });
  };

  handleSelectedItem2 = (control: any, id: any) => {
    let formData = { ...this.state.formData };
    if (control == 2) {
      let bankid = this.state.bankList.filter((x) => x.id == id);
      let bankname = bankid.length > 0 ? bankid[0].name : "";
      formData.bankId = id;
      localStorage.setItem("selectedBankId", id);
      this.setState(
        {
          formData,
          bankname,
        },
        () => {
          this.getVOItems(id);
        }
      );
    }
  };

  rowEvents = (row: any) => {
    const etype = row.etype?.toLowerCase();
    if (etype?.includes("withdarawal")) {
      this.setState({
        openWithdrawal: true,
        transactionId: row.id,
      });
    } else if (etype?.includes("deposit")) {
      this.setState({
        openDeposit: true,
        transactionId: row.id,
      });
    } else if (etype?.includes("purchasing")) {
      this.setState({
        openInvoice: true,
        transactionId: row.id,
      });
    } else if (
      etype?.includes("transferto") ||
      etype?.includes("transferfrom")
    ) {
      this.setState({
        openTransfer: true,
        transactionId: row.id,
      });
    }
  };

  rowEventsFind = {
  onClick: (e, row, rowIndex) => {
    const etype = row.etype2?.toLowerCase();

    if (etype?.includes("withdarawal")) {
      this.setState({
        openWithdrawal: true,
        transactionId: row.id,
      });
    } else if (etype?.includes("deposit")) {
      this.setState({
        openDeposit: true,
        transactionId: row.id,
      });
    } else if (etype?.includes("purchasing")) {
      this.setState({
        openInvoice: true,
        transactionId: row.id,
      });
    } else if (
      etype?.includes("transferto") ||
      etype?.includes("transferfrom")
    ) {
      this.setState({
        openTransfer: true,
        transactionId: row.id,
      });
    }
  },
};


  bindfilter = () => {
    let selectOptions = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.selectOptions))
    );

    this.setState({ selectOptions: selectOptions });
  };

  isdeleteconfirm(id: any) {
    let masg = "";

    masg = "Are you sure you want to remove record?";

    confirmAlert({
      title: "Delete Record",

      message: masg,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.ishandleDeleteRow(id),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],

      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  ishandleDeleteRow = (id: any) => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.id = id;
    TransactionService.DeleteBankSync(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          toast.success("Record has been deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });

          this.setState({ isSpinner: false }, () => {
            this.getVOItems(this.state.formData.bankId);
          });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };
  handleSelectedItem1 = (control: any, id: any) => {
    const matchedItem = this.state.selectOptions.find((item) => item.id == id);

    if (matchedItem) {
      this.setState(
        {
          selectedid: id,
          selectedcolumn: matchedItem.name,
        },
        () => {
          this.getBankSyncAll();
        }
      );
    }
  };

  handleOnSelect = (row, isSelect) => {
    console.log("Single row selection", row.totalAmount, row.rowId, row);

    let {
      invoiceTotal,
      selectedRows,
      selectedcustomerid,
      selectedRowscustomerid,
      itemsIds,
    } = this.state;
    const flag = selectedRows[0] !== row.orderID;
    let customerOrderResult = Object.assign(
      [],
      JSON.parse(
        JSON.stringify(
          flag
            ? this.state.customerOriginalOrderResult
            : this.state.customerOrderResult
        )
      )
    );

    // if(selectedRows[0] !== row.orderID){
    //   toast.error("You can make an invoice of one PO at a time");
    //   return;
    // }

    const rowId = row.rowId;
    const customerID = row.customerID;

    let listItems = customerOrderResult.filter((x) => x.rowId === rowId);

    let checklistItem = this.state.selectedRowscustomerid.filter(
      (x) => x !== customerID
    );

    // console.log("isSelect, row", isSelect, row);
    // console.log("checklistItem", checklistItem);
    // console.log("invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid", invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid);
    // console.log("customerOrderResult", customerOrderResult);

    if (checklistItem.length === 0) {
      if (isSelect) {
        invoiceTotal = flag
          ? row.unitPrice * row.qtyOrdered
          : invoiceTotal + row.unitPrice * row.qtyOrdered;
      } else {
        invoiceTotal = flag
          ? row.unitPrice * row.qtyOrdered
          : invoiceTotal - row.unitPrice * row.qtyOrdered;
      }

      if (isSelect) {
        selectedRows = flag
          ? [...this.state.selectedRows, row.orderID]
          : [...this.state.selectedRows, row.orderID];
        itemsIds = flag ? [row.itemNo] : [...this.state.itemsIds, row.itemNo];
        selectedRowscustomerid = flag
          ? [row.customerID]
          : [...this.state.selectedRowscustomerid, row.customerID];
      } else {
        selectedRows = this.state.selectedRows.filter((x) => x !== row.orderID);
        itemsIds = this.state.itemsIds.filter((x) => x !== row.itemNo);
        selectedRowscustomerid = this.state.selectedRowscustomerid.filter(
          (x) => x !== row.customerID
        );
      }
    } else {
      toast.error(
        "If you make one invoice for multiple orders, the customer should be the same."
      );
    }

    if (checklistItem.length == 0) {
      if (listItems.length > 0) {
        listItems.forEach((element: any, index: any) => {
          if (checklistItem.length == 0) {
            element.selected = isSelect;
          }
        });
      }
    }

    console.log(
      " selectedRows, selectedcustomerid, selectedRowscustomerid",
      selectedRows,
      selectedcustomerid,
      selectedRowscustomerid
    );

    this.setState({
      customerOrderResult: customerOrderResult,
      footershow: itemsIds.length > 0 ? true : false,
      invoiceTotal: invoiceTotal,
      selectedRows: selectedRows,
      itemsIds: itemsIds,
      selectedRowscustomerid: selectedRowscustomerid,
    });
  };

  handleOnSelectApproval1 = (row, isSelect) => {
    let { selectedRows1 } = this.state;

    let searchedData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searchedData))
    );

    let listItem = searchedData.filter((x) => x.uniqueid === row.uniqueid);

    if (isSelect) {
      selectedRows1 = [...this.state.selectedRows1, row.uniqueid];
    } else {
      selectedRows1 = this.state.selectedRows1.filter(
        (x) => x !== row.uniqueid
      );
    }

    listItem[0].selected = isSelect;
    this.setState({
      searchedData: searchedData,
      selectedRows1: selectedRows1,
    });
  };

  handleOnSelectAllApproval1 = (isSelect, rows) => {
    const ids = rows.map((r) => r.id);
    let { selectedRows1 } = this.state;

    let searchedData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searchedData))
    );

    let listItems = searchedData.filter((x) => ids.includes(x.id));

    if (isSelect) {
      selectedRows1 = [...this.state.selectedRows1, rows[0].id];
    } else {
      selectedRows1 = this.state.selectedRows1.filter((x) => x !== rows[0].id);
    }

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    }

    this.setState({
      searchedData: searchedData,
      selectedRows1: selectedRows1,
    });
  };

  handleChange = (event: any, FieldType: string, index: any) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let adjData = { ...this.state.adjData };

    if (FieldType === "date") {
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      adjData.date = today;
      this.setState({ adjData, isStateChanged });
    }
  };

  handleOnSelectApproval2 = (row, isSelect) => {
    let { invoiceTotal, selectedRows2 } = this.state;

    let customerOrderResult = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customerOrderResult))
    );

    let listItem = customerOrderResult.filter((x) => x.id === row.id);

    if (isSelect) {
      selectedRows2 = [...this.state.selectedRows2, row.id];
    } else {
      selectedRows2 = this.state.selectedRows2.filter((x) => x !== row.id);
    }

    listItem[0].selected = isSelect;
    let selectedCount = customerOrderResult.filter(
      (x) => x.selected == true && x.status == "excluded"
    ).length;

    this.setState({
      customerOrderResult: customerOrderResult,
      footershow2: selectedCount > 0 ? true : false,
      selectedRows2: selectedRows2,
    });
  };

  handleOnSelectApproval = (row, isSelect) => {
    let { invoiceTotal, selectedRows } = this.state;

    let customerOrderResult = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customerOrderResult))
    );

    let listItem = customerOrderResult.filter((x) => x.id === row.id);

    if (isSelect) {
      selectedRows = [...this.state.selectedRows, row.id];
    } else {
      selectedRows = this.state.selectedRows.filter((x) => x !== row.id);
    }

    if (isSelect) {
      invoiceTotal += row.amount;
    } else {
      invoiceTotal -= row.amount;
    }

    listItem[0].selected = isSelect;
    let selectedCount = customerOrderResult.filter(
      (x) => x.selected == true && x.status == "review"
    ).length;

    this.setState({
      customerOrderResult: customerOrderResult,
      footershow: selectedCount > 0 ? true : false,
      invoiceTotal: invoiceTotal,
      selectedRows: selectedRows,
    });
  };

  handleOnSelectAllApproval = (isSelect, rows) => {
    const ids = rows.map((r) => r.id);
    let {
      invoiceTotal,
      selectedRows,
      selectedcustomerid,
      selectedRowscustomerid,
    } = this.state;
    let invoiceList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.invoiceList))
    );

    let listItems = invoiceList.filter((x) => ids.includes(x.id));

    if (isSelect) {
      invoiceTotal += rows[0].totalAmount;
      selectedcustomerid = rows[0].customerID;
    } else {
      invoiceTotal -= rows[0].totalAmount;
      selectedcustomerid = 0;
    }

    if (isSelect) {
      selectedRows = [...this.state.selectedRows, rows[0].id];
    } else {
      selectedRows = this.state.selectedRows.filter((x) => x !== rows[0].id);
    }

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    }

    this.setState({
      invoiceList: invoiceList,
      footershow: isSelect ? true : false,
      invoiceTotal: invoiceTotal,
      selectedRows: selectedRows,
      selectedRowscustomerid: selectedRowscustomerid,
    });
  };

  handleOnSelectAll = (isSelect, rows) => {
    console.log("rowww", rows);

    let checklistItem = this.state.selectedRowscustomerid.filter(
      (x) => x !== rows[0].customerID
    );

    const ids = rows.map((r) => r.rowId);
    let {
      invoiceTotal,
      selectedRows,
      selectedcustomerid,
      selectedRowscustomerid,
    } = this.state;
    console.log(
      "invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid",
      invoiceTotal,
      selectedRows,
      selectedcustomerid,
      selectedRowscustomerid
    );

    // if(selectedRows[0] !== rows[0].customerID){
    //   toast.error("You can make an invoice of one PO at a time");
    //   return;
    // }

    let customerOrderResult = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customerOriginalOrderResult))
    );

    let listItems = customerOrderResult.filter((x) => ids.includes(x.rowId));

    if (checklistItem.length == 0) {
      if (isSelect) {
        invoiceTotal = rows[0].totalAmount;
        selectedcustomerid = rows[0].customerID;
      } else {
        invoiceTotal = rows[0].totalAmount;
        selectedcustomerid = 0;
      }

      if (isSelect) {
        selectedRows = [rows[0].orderID];
        selectedRowscustomerid = [rows[0].customerID];
      } else {
        // selectedRows = this.state.selectedRows.filter(x => x !== rows[0].orderID);
        selectedRows = [];

        selectedRowscustomerid = this.state.selectedRowscustomerid.filter(
          (x) => x !== rows[0].customerID
        );
      }
    } else {
      toast.error(
        "if you make one invoice for multiples order then customer should be same "
      );
    }

    if (checklistItem.length == 0) {
      if (listItems.length > 0) {
        listItems.forEach((element: any, index: any) => {
          if (checklistItem.length == 0) {
            element.selected = isSelect;
          }
        });
      }
    }
    console.log("customerOrderResult---", customerOrderResult);

    this.setState({
      customerOrderResult: customerOrderResult,
      footershow: selectedRows.length > 0 ? true : false,
      invoiceTotal: invoiceTotal,
      selectedRows: selectedRows,
      selectedRowscustomerid: selectedRowscustomerid,
    });
  };

  moreOptions = (eventKey: any, row: any) => {
    if (eventKey == "deposit") {
      this.setState({
        openDeposit: true,
        slideoutAmount: row.amount,
        slideoutDate: row.date,
        slideoutId: row.id,
        transactionId: 0,
      });
    } else if (eventKey == "withdrawal") {
      this.setState({
        openWithdrawal: true,
        slideoutAmount: row.amount,
        slideoutId: row.id,
        slideoutDate: row.date,
        transactionId: 0,
      });
    } else if (eventKey == "transfer") {
      this.setState({
        openTransfer: true,
        slideoutAmount: row.amount,
        transactionId: 0,
      });
    }
  };

  closeDepositslideout = () => {
    this.setState({
      openDeposit: false,
      transactionId: 0,
      slideoutDate: null,
      slideutId: 0,
    });
    if (this.state.transactionId == 0)
      this.getVOItems(this.state.formData.bankId);
  };

  closeWithdrawalslideout = () => {
    this.setState({
      openWithdrawal: false,
      transactionId: 0,
      slideoutDate: null,
      slideutId: 0,
    });
    if (this.state.transactionId == 0)
      this.getVOItems(this.state.formData.bankId);
  };

  closeTransferslideout = () => {
    this.setState({
      openTransfer: false,
      transactionId: 0,
      slideoutDate: null,
      slideutId: 0,
    });
    if (this.state.transactionId == 0)
      this.getVOItems(this.state.formData.bankId);
  };

  closeInvoiceslideout = () => {
    this.setState({ openInvoice: false, transactionId: 0 });
  };

  render() {
    const { permissions } = this.props;
    const { openDeposit, openWithdrawal, openTransfer, openInvoice } =
      this.state;

    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );

    const getFilteredLength = () => {
      const { activeKey, customerOrderResult } = this.state;

      if (activeKey === "first") {
        return customerOrderResult.filter(
          (x) => x.rowtype === 1 && x.status === "review"
        ).length;
      }

      if (activeKey === "second") {
        return customerOrderResult.filter(
          (x) => x.rowtype === 1 && x.status === "completed"
        ).length;
      }

      if (activeKey === "third") {
        return customerOrderResult.filter(
          (x) => x.rowtype === 1 && x.status === "excluded"
        ).length;
      }

      return 0;
    };

    const options = {
      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "25",
          value: 25,
        },
        {
          text: "50",
          value: 50,
        },

        {
          text: "All",
          value: getFilteredLength(),
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };

    const invoiceColumnsPaid = [
      {
        dataField: "date",
        text: "Date",
        sort: true,
        headerStyle: { width: "20%" },
        searchable: true,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.date).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
        searchable: true,
        headerStyle: { width: "20%" },
        classes: "text-truncate text-start",
        formatter: (cell: any) => (
          <div className="d-flex align-items-center txt-bold">
            <div style={{ width: "150px" }}>
              <EllipsisWithTooltip placement="bottom">
                {cell}
              </EllipsisWithTooltip>
            </div>
          </div>
        ),
      },

      {
        dataField: "type",
        text: "Type/Check",
        headerClasses: "text-center",
        classes: "text-center",
        headerStyle: { width: "10%" },
      },

      {
        dataField: "amount",
        text: "Amount",
        headerClasses: "text-end",
        classes: "text-end pe-4",
        sort: false,
        searchable: true,
        //this.state.ispayment,
        headerStyle: { width: "20%" },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(row.amount)}
            </EllipsisWithTooltip>
          );
        },
        filterValue: (cell, row) => {
          return row.amount.toFixed(2);
        },
      },
      {
        dataField: "matchedEntry",
        text: "Matched Record",
        headerStyle: { width: "30%" },
        headerClasses: "text-center",
        classes: "text-center",
        sort: true,
        sortValue: (cell, row) => {
          const matches = this.state.customerOrderResult.filter(
            (item) => item.parentid === row.id
          );

          return matches.length;
        },
        formatter: (cell, row) => {
          const matches = this.state.customerOrderResult.filter(
            (item) => item.parentid === row.id
          );

          const count = matches.length;

          if (count == 1) {
            const match = matches[0];
            return (
              <span className="divgreen">
                {moment(match.date).format("MM/DD/YYYY")},{" "}
                {Utils.currencyFormat(match.amount)}
              </span>
            );
          }

          return (
            <span className="divgreen">
              {count > 0 ? `${count} transactions` : ""}
            </span>
          );
        },
      },
      {
        dataField: "review",
        text: "Review",
        isDummyField: true,
        headerStyle: { width: "20%" },
        headerClasses: "text-center",
        classes: "text-center",
        formatter: (_: any, row: any) => {
          const isExpanded = this.state.expandedRows.includes(row.id);
          console.log("isexpanded", isExpanded);
          return (
            <button
              type="button"
              className=" custom-reconcile-btn"
              onClick={() => {
                const updatedData = this.state.customerOrderResult.map(
                  (item, index) => {
                    if (item.id == row.id) {
                      return { ...item, isExpanded: !item.isExpanded };
                    } else {
                      return { ...item, isExpanded: false };
                    }
                  }
                );

                this.setState(
                  {
                    customerOrderResult: updatedData,
                    selectedReviewId: 0,
                    maintype: row.type,
                  },
                  () => {
                    if (!row.isExpanded) {
                      this.getBankSyncAll();
                    }
                  }
                );
              }}
            >
              {row.isExpanded ? "Close" : "Review"}
            </button>
          );
        },
      },
      {
        dataField: "",
        text: "",
        headerStyle: { width: "2%" },

        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="btn-group">
              <Dropdown
                // onClick={(e) => { e.stopPropagation(); }}
                className="more-action"
              >
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary-white more"
                  id={"dropdown-more" + rowIndex}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    eventKey={"deleterow"}
                    onClick={() => this.isdeleteconfirm(row.id)}
                  >
                    Remove
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    ];

    const ColumnExcluded1 = [
      {
        dataField: "date",
        text: "Date",
        sort: true,
        headerStyle: { width: "20%" },
        searchable: this.state.isdate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.date).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
        searchable: true,
        headerStyle: { width: "25%" },
        classes: "text-truncate text-start",
        formatter: (cell: any) => (
          <div className="d-flex align-items-center txt-bold">
            <div style={{ width: "250px" }}>
              <EllipsisWithTooltip placement="bottom">
                {cell}
              </EllipsisWithTooltip>
            </div>
          </div>
        ),
      },

      {
        dataField: "type",
        text: "Type",
        headerClasses: "text-center",
        classes: "text-center",
        headerStyle: { width: "10%" },
      },

      {
        dataField: "amount",
        text: "Amount",
        headerClasses: "text-center",
        classes: "text-center pe-4",
        sort: false,
        searchable: true,
        //this.state.ispayment,
        headerStyle: { width: "20%" },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(row.amount)}
            </EllipsisWithTooltip>
          );
        },
        filterValue: (cell, row) => {
          return row.amount.toFixed(2);
        },
      },
      {
        dataField: "",
        text: "",
        headerStyle: { width: "20%" },
      },
    ];

    const ColumnExcluded = [
      {
        dataField: "date",
        text: "Date",
        sort: true,
        headerStyle: { width: "20%" },
        searchable: this.state.isdate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.date).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
        searchable: true,
        headerStyle: { width: "25%" },
        classes: "text-truncate text-start",
        formatter: (cell: any) => (
          <div className="d-flex align-items-center txt-bold">
            <div style={{ width: "250px" }}>
              <EllipsisWithTooltip placement="bottom">
                {cell}
              </EllipsisWithTooltip>
            </div>
          </div>
        ),
      },

      {
        dataField: "type",
        text: "Type",
        headerClasses: "text-center",
        classes: "text-center",
        headerStyle: { width: "10%" },
      },

      {
        dataField: "amount",
        text: "Amount",
        headerClasses: "text-center",
        classes: "text-center pe-4",
        sort: false,
        searchable: true,
        //this.state.ispayment,
        headerStyle: { width: "20%" },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(row.amount)}
            </EllipsisWithTooltip>
          );
        },
        filterValue: (cell, row) => {
          return row.amount.toFixed(2);
        },
      },
      {
        dataField: "matchedEntry",
        text: "Matched Record",
        headerStyle: { width: "30%" },
        headerClasses: "text-start",
        classes: "text-truncate text-start",
        sort: true,
        sortValue: (cell, row) => {
          const matches = this.state.customerOrderResult.filter(
            (item) => item.parentid === row.id
          );

          return matches.length;
        },
        formatter: (cell, row) => {
          const matches = this.state.customerOrderResult.filter(
            (item) => item.parentid === row.id && item.rowtype == 3
          );

          if (matches.length === 0) {
            return <span className="divgreen">&nbsp;</span>;
          }

          const formatted = matches
            .map(
              (m) =>
                `${moment(m.date).format("MM/DD/YYYY")} ${Utils.currencyFormat(
                  m.amount
                )} - ${m.vendor}`
            )
            .join(", ");

          return (
            <div
              style={{ width: "250px", cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                this.rowEvents(matches[0]);
              }}
              className="divgreen"
            >
              <EllipsisWithTooltip placement="bottom">
                {formatted}
              </EllipsisWithTooltip>
            </div>
          );
        },
      },

      {
        dataField: "adj",
        text: "Adj.",
        headerClasses: "text-end",
        classes: "text-end pe-4",
        sort: false,
        searchable: false,
        //this.state.ispayment,
        headerStyle: { width: "20%" },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.adj ? Utils.currencyFormat(row.adj) : "-"}
            </EllipsisWithTooltip>
          );
        },
        filterValue: (cell, row) => {
          return row.amount.toFixed(2);
        },
      },
    ];

    const invoiceColumnsPaidAll = [
      {
        dataField: "date",
        text: "Date",
        sort: true,
        classes: "expanding-bar",
        // headerStyle: { width: "100px" },
        searchable: true,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.paydate == null || row.paydate == undefined
                ? ""
                : moment(row.paydate).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "vendor",
        text: "Vendor",
        sort: true,
        searchable: true,
      },
      {
        dataField: "etype2",
        text: "",
        // sort: true,
        searchable: true,
        formatter: (cell, row) => {
          return "Register";
        },
      },

      {
        dataField: "amount",
        text: "Total",
        headerClasses: "text-end",
        classes: "text-end pe-4 expanding-bar",
        sort: true,
        searchable: true,
        // headerStyle: { width: "100px" },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(row.amount)}
            </EllipsisWithTooltip>
          );
        },
        filterValue: (cell, row) => {
          return row.amount.toFixed(2);
        },
      },
    ];

    const expandSplitRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      bgColor: "#00BFFF",
      // renderer: (row: any, rowIndex: any) =>
      //   renderItemTableChild(row, rowIndex),
      renderer: (row, rowIndex) => {
        const matchingRows = this.state.customerOrderResult.filter(
          (item) => item.parentid == row.id
        );

        const type = row.type;
        return (
          <div className="ps-4 py-3">
            <Tab.Container defaultActiveKey="review" transition={false}>
              <div className="nav-box">
                <Nav variant="underline" className="nav-box-tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="review" className="fs-6">
                      Review ({matchingRows.length})
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="find" className="fs-6">
                      Find
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="add" className="fs-6">
                      Add
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <div className="tabs-divider"></div>

                <Tab.Content>
                  <Tab.Pane eventKey="review">
                    <section className="mt-2 p-3">
                      {matchingRows.length > 0 ? (
                        matchingRows.map((match, idx) => (
                          <div
                            key={idx}
                            className="d-flex gap-2 mb-2 align-items-center divgreen2"
                          >
                            <input
                              type="radio"
                              name={`match-radio-${row.uniqueid}`}
                              value={match.uniqueid}
                              // defaultChecked={idx === 0}
                              onChange={() =>
                                this.setState({
                                  selectedReviewId: match.uniqueid,
                                })
                              }
                            />
                            <label>
                              <strong
                                onClick={() => this.rowEvents(match)}
                                className="cursor-pointer"
                              >
                                {moment(match.date).format("MM/DD/YYYY")},{" "}
                                {Utils.currencyFormat(match.amount)} -{" "}
                                {match.vendor}
                              </strong>
                            </label>
                          </div>
                        ))
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          No matching data found.
                        </div>
                      )}{" "}
                    </section>
                    {matchingRows.length > 0 && (
                      <div className="tab-footer-common">
                        <div className="footer-sections"></div>
                        <div className="action-buttons">
                          <button
                            type="button"
                            className="btn"
                            style={{
                              backgroundColor: "#15b79e",
                              color: "white",
                              borderRadius: 0,
                            }}
                            onClick={() =>
                              this.reconcileData("single", row.uniqueid)
                            }
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="find">
                    <section className="mt-2 p-3">
                      <ToolkitProvider
                        keyField="uniqueid"
                        data={this.state.searchedData}
                        columns={invoiceColumnsPaidAll}
                        search
                      >
                        {(props) => (
                          <div>
                            <section className="d-flex flex-wrap gap-3 pb-2 mt-2">
                              <div className="position-relative">
                                <SearchBar {...props.searchProps} />
                              </div>

                              <div className="col-12 col-md-2">
                                <SingleDropdownListWithoutSearch
                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(
                                    this,
                                    1
                                  )}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}
                                />
                              </div>
                            </section>

                            <section>
                              <div className="table-responsive">
                                <BootstrapTable
                                  {...props.baseProps}
                                  id="tblCOAchild"
                                  wrapperClasses="table-responsive fixed-header-table"
                                  classes="table-striped table-bordered"
                                  selectRow={{
                                    mode: "checkbox",
                                    clickToSelect: false,
                                    hideSelectAll: true,
                                    selected: this.state.searchedData
                                      .filter((x) => x.selected === true)
                                      .map((r) => r.uniqueid),
                                    onSelect: this.handleOnSelectApproval1,
                                    onSelectAll:
                                      this.handleOnSelectAllApproval1,
                                    hideSelectColumn: false,
                                  }}
                                  rowEvents={this.rowEventsFind}
                                />
                              </div>
                            </section>
                          </div>
                        )}
                      </ToolkitProvider>
                    </section>
                    {this.state.searchedData.length > 0 && (
                      <div className="tab-footer-common">
                        <div className="footer-sections"></div>
                        <div className="action-buttons">
                          <button
                            type="button"
                            className="btn"
                            style={{
                              backgroundColor: "#15b79e",
                              color: "white",
                              borderRadius: 0,
                            }}
                            onClick={() =>
                              this.reconcileData("multiple", row.uniqueid)
                            }
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="add">
                    <section className="mt-2 p-3">
                      <div className="d-flex justify-content-start">
                        <Dropdown
                          className="more-action"
                          onSelect={(event) => {
                            this.moreOptions(event, row);
                          }}
                        >
                          <Dropdown.Toggle className="addNewVendor">
                            Add Transaction
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {type === "Deposit" ? (
                              <Dropdown.Item eventKey="deposit">
                                Deposit
                              </Dropdown.Item>
                            ) : (
                              <Dropdown.Item eventKey="withdrawal">
                                Withdrawal
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </section>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        );
      },
      showExpandColumn: true,
      expandByColumnOnly: true,
      expanded: this.state.customerOrderResult
        .filter((r) => r.isExpanded)
        .map((r) => r.id),
      onExpand: (row, isExpand) => {
        const updated = this.state.customerOrderResult.map((item) => {
          if (item.id === row.id) {
            return { ...item, isExpanded: isExpand };
          } else {
            return { ...item, isExpanded: false };
          }
        });

        this.setState(
          {
            customerOrderResult: updated,
            selectedReviewId: 0,
            maintype: row.type,
          },
          () => {
            if (isExpand) {
              this.getBankSyncAll();
            }
          }
        );
      },

      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          // this.setState({expanded:expanded},()=>{
          //   $('.selection-cell input').css('display', 'none');
          // });
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };

    const expandSplitRowCompleted = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      bgColor: "#00BFFF",
      nonExpandable: this.state.customerOrderResult
        .filter((r) => {
          const childCounts = this.state.customerOrderResult.reduce(
            (count, item) =>
              count + (item.parentid === r.id && item.rowtype === 3 ? 1 : 0),
            0
          );
          return childCounts <= 1;
        })
        .map((r) => r.id),
      renderer: (row, rowIndex) => {
        const matchingRows = this.state.customerOrderResult.filter(
          (item) => item.parentid == row.id && item.rowtype == 3
        );
        return (
          <div className="ps-4 py-3">
            <div className="nav-box">
              <section className="mt-2 p-3">
                {matchingRows.length > 0 ? (
                  matchingRows.map((match, idx) => (
                    <div
                      key={idx}
                      className="d-flex gap-2 mb-2 align-items-center cursor-pointer divgreen2"
                    >
                      <strong
                        onClick={() => this.rowEvents(match)}
                        className="divgreen2"
                      >
                        {moment(match.date).format("MM/DD/YYYY")},{" "}
                        {Utils.currencyFormat(match.amount)} - {match.vendor}
                      </strong>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: "center" }}>No Adjustment.</div>
                )}{" "}
              </section>
            </div>
          </div>
        );
      },
      showExpandColumn: true,
      expandByColumnOnly: true,
      expanded: this.state.customerOrderResult
        .filter((r) => r.isExpanded)
        .map((r) => r.id),

      onExpand: (row, isExpand) => {
        const updated = this.state.customerOrderResult.map((item) => {
          if (item.id === row.id) {
            return { ...item, isExpanded: isExpand };
          } else {
            return { ...item, isExpanded: false };
          }
        });

        this.setState({
          customerOrderResult: updated,
        });
      },

      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded, expandable }) => {
        if (!expandable) return null;
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };

    return (
      <>
        <React.Fragment>
          <Container fluid className="body-sec">
            <div className="page-heading d-flex">
              Bank Sync
              <div className="action-group d-flex flex-row ml-auto">
                <Button
                  className="addNewVendor"
                  id="saveBtn"
                  tabIndex={15}
                  onClick={() => this.redirectToReconciliation()}
                >
                  Reconciliation
                </Button>

                <Button onClick={this.showBankslideout}>
                  Manual Statement Upload
                </Button>
              </div>
            </div>
            <section className="d-flex flex-wrap justify-content-between  gap-2 pb-2 underline pb-3">
              <div className="col-12 col-md-2" style={{ marginTop: "6px" }}>
                <Form.Group controlId="buyerName">
                  <div className="parent my-data">
                    <div className="w-auto">
                      {this.state.bankList.length > 0 && (
                        <SingleDropdownListWithoutSearch
                          tabIndex={this.state.tabEnable}
                          itemList={this.state.bankList}
                          handleSelectedItem={this.handleSelectedItem2.bind(
                            this,
                            2
                          )}
                          defaultItem={this.state.bankname}
                          defaultText={"Select Account"}
                          defaultName={this.state.bankname}
                          controlID="1"
                          id={"ddlBank"}
                          isBank={true}
                        />
                      )}
                    </div>
                  </div>
                </Form.Group>
              </div>
              <div className="text-muted align-self-center">
                {this.state.lastUploadText}
              </div>
            </section>
            <Tab.Container
              transition={false}
              defaultActiveKey="first"
              onSelect={(key) => {
                this.setState({ activeKey: key });
                this.getVOItems(this.state.formData.bankId);
              }}
            >
              <section className="pb-3">
                <Nav className="nav nav-underline border-bottom">
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="first">
                      Review
                      <span className="badge badge-light">
                        {" "}
                        {
                          this.state.customerOrderResult.filter(
                            (x) => x.rowtype == 1 && x.status == "review"
                          ).length
                        }
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="second">
                      Completed
                      <span className="badge badge-light">
                        {" "}
                        {
                          this.state.customerOrderResult.filter(
                            (x) => x.status === "completed" && x.rowtype == 1
                          ).length
                        }
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="third">
                      Excluded
                      <span className="badge badge-light">
                        {" "}
                        {
                          this.state.customerOrderResult.filter(
                            (x) => x.status === "excluded" && x.rowtype == 1
                          ).length
                        }
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </section>

              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <section>
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.customerOrderResult.filter(
                        (item) => item.rowtype === 1 && item.status == "review"
                      )}
                      columns={invoiceColumnsPaid}
                      search
                    >
                      {(props) => (
                        <div>
                          <section className="d-flex flex-wrap gap-3 pb-2 mt-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                            </div>
                          </section>
                          <section className="pb-3">
                            <div className="divbottom">
                              <div className="ml-auto transactions-list  expand-tbl">
                                <BootstrapTable
                                  id="tblCO"
                                  {...props.baseProps}
                                  // keyField="id"
                                  key={this.state.formData.bankId}
                                  expandRow={expandSplitRow}
                                  selectRow={{
                                    mode: "checkbox",
                                    clickToSelect: false,
                                    hideSelectAll: true,
                                    selected: this.state.customerOrderResult
                                      .filter(
                                        (x) =>
                                          x.selected === true &&
                                          x.status == "review"
                                      )
                                      .map((r) => r.id),
                                    onSelect: this.handleOnSelectApproval,
                                    onSelectAll: this.handleOnSelectAllApproval,
                                    hideSelectColumn: false,
                                  }}
                                  pagination={paginationFactory(options)}
                                   rowClasses={(row, rowIndex) =>
                                  row.rowtype === 1 && row.status == "review" ? "main-row" : "expand-row"
                                }
                                />
                                {this.state.footershow && (
                                  <div
                                    className="TabFooter-Pay"
                                    style={{
                                      minWidth: "83.7%",
                                      width: "992px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    <div className="bulkSelectFooter">
                                      <span className="shift-selected-count">
                                        {this.state.selectedRows.length}{" "}
                                        Selected
                                      </span>
                                      <div className="FooterHorLine"></div>
                                      <span className="shift-selected-count">
                                        Total:{" "}
                                        {Utils.currencyFormatWithOutdoller(
                                          this.state.invoiceTotal
                                        )}
                                      </span>
                                      <div className="action-group d-flex flex-row mr-auto">
                                        <Button
                                          type="button"
                                          //className="btn-outline-primary btnHeight"
                                          //  onClick={(e) => { this.handleBtnEvent(e, "", 'bulk') }}
                                          onClick={(x) => this.excludeRecord()}
                                        >
                                          Exclude
                                        </Button>
                                        <Button
                                          type="button"
                                          className="space btn btn-primary btn-discard"
                                          onClick={(x) => this.discard()}
                                        >
                                          Discard
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    </ToolkitProvider>
                  </section>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <section>
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.customerOrderResult.filter(
                        (item) =>
                          item.rowtype === 1 && item.status == "completed"
                      )}
                      columns={ColumnExcluded}
                      search
                    >
                      {(props) => (
                        <div>
                          <section className="d-flex flex-wrap gap-3 pb-2 mt-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                            </div>
                          </section>
                          <section className="pb-3">
                            <div className="divbottom">
                              <div className="ml-auto transactions-list payroll-tbl">
                                <BootstrapTable
                                  id="tblCO"
                                  {...props.baseProps}
                                  // keyField="id"
                                  key={this.state.formData.bankId}
                                  expandRow={expandSplitRowCompleted}
                                  pagination={paginationFactory(options)}
                                />
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    </ToolkitProvider>
                  </section>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <section>
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.customerOrderResult.filter(
                        (item) =>
                          item.rowtype === 1 && item.status == "excluded"
                      )}
                      columns={ColumnExcluded1}
                      search
                    >
                      {(props) => (
                        <div>
                          <section className="d-flex flex-wrap gap-3 pb-2 mt-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                            </div>
                          </section>
                          <section className="pb-3">
                            <div className="divbottom">
                              <div className="ml-auto transactions-list payroll-tbl">
                                <BootstrapTable
                                  id="tblCO"
                                  {...props.baseProps}
                                  // keyField="id"
                                  key={this.state.formData.bankId}
                                  selectRow={{
                                    mode: "checkbox",
                                    clickToSelect: false,
                                    hideSelectAll: true,
                                    selected: this.state.customerOrderResult
                                      .filter(
                                        (x) =>
                                          x.selected === true &&
                                          x.status == "excluded"
                                      )
                                      .map((r) => r.id),

                                    onSelect: this.handleOnSelectApproval2,
                                    // onSelectAll: this.handleOnSelectAllApproval,
                                    hideSelectColumn: false,
                                  }}
                                  pagination={paginationFactory(options)}
                                />
                                {this.state.footershow2 && (
                                  <div
                                    className="TabFooter-Pay"
                                    style={{
                                      minWidth: "83.7%",
                                      width: "992px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    <div className="bulkSelectFooter">
                                      <span className="shift-selected-count">
                                        {this.state.selectedRows2.length}{" "}
                                        Selected
                                      </span>
                                      {/* <div className="FooterHorLine"></div> */}
                                      {/* <span className="shift-selected-count">
                                  Invoice Total:{" "}
                                  {Utils.currencyFormatWithOutdoller(
                                    this.state.invoiceTotal
                                  )}
                                </span> */}
                                      <div className="action-group d-flex flex-row mr-auto">
                                        <Button
                                          type="button"
                                          onClick={(x) => this.includeRecord()}
                                        >
                                          Include
                                        </Button>
                                        <Button
                                          type="button"
                                          className="space btn btn-primary btn-discard"
                                          onClick={(x) => this.discard2()}
                                        >
                                          Discard
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    </ToolkitProvider>
                  </section>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Container>

          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

          {this.state.showPopup && (
            <BankSyncModal
              bankid={this.state.formData.bankId}
              showModal={this.state.showPopup}
              onClose={this.closeModal1}
            />
          )}

          {openDeposit && (
            <DepositSlideout
              transactionID={this.state.transactionId}
              bankId={this.state.formData.bankId}
              bankname={this.state.bankname}
              slideoutAmount={this.state.slideoutAmount}
              slideoutDate={this.state.slideoutDate}
              slideoutId={this.state.slideoutId}
              closeSlideOut={this.closeDepositslideout}
            />
          )}

          {openWithdrawal && (
            <WithdrawalSlideout
              transactionID={this.state.transactionId}
              bankId={this.state.formData.bankId}
              bankname={this.state.bankname}
              slideoutAmount={this.state.slideoutAmount}
              slideoutDate={this.state.slideoutDate}
              slideoutId={this.state.slideoutId}
              closeSlideOut={this.closeWithdrawalslideout}
            />
          )}

          {openTransfer && (
            <TransferSlideout
              transferID={this.state.transactionId}
              slideoutAmount={this.state.slideoutAmount}
              closeSlideOut={this.closeTransferslideout}
            />
          )}

          {openInvoice && (
            <InvoiceSlideout
              transactionID={this.state.transactionId}
              closeSlideOut={this.closeInvoiceslideout}
            />
          )}

          {/* ADJUSTMENT MODAL */}
          <Modal
            className="confirm-modal"
            show={this.state.showPopup1}
            onHide={() => {
              this.setState({ showPopup1: false });
            }}
            centered
          >
            <Modal.Header>
              <Modal.Title>Add Adjustment</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form.Group controlId="formDescription">
                <div className="row mb-3">
                  <div className="col-6">
                    <Form.Label className="font-semibold">Location</Form.Label>
                    <Form.Control
                      value={this.state.adjData.location}
                      placeholder="Enter location"
                      disabled={true}
                    />
                  </div>
                  <div className="col-6">
                    <Form.Label className="font-semibold">COA</Form.Label>
                    <Form.Control
                      value={this.state.adjData.coa}
                      onChange={(e) => {
                        this.setState({ editingDesc: e.target.value });
                      }}
                      placeholder="Enter COA"
                      disabled={true}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-6">
                    <Form.Label className="font-semibold">Date</Form.Label>
                    <div className="date-picker calender-picker">
                      <DatePicker
                        ref={this.trDate}
                        id="txtInvoiceDate"
                        className="form-control px-0 w-full text-center pe-5"
                        placeholderText="MM/DD/YY"
                        dateFormat="MM/dd/yy"
                        selected={
                          this.state.adjData.date === null ||
                          this.state.adjData.date === ""
                            ? new Date(
                                Utils.convertUtcToTimezoneFormat(
                                  new Date(),
                                  currentUtcTime
                                )
                              )
                            : new Date(this.state.adjData.date)
                        }
                        disabled={false}
                        onChange={(event) =>
                          this.handleChange(event, "date", 0)
                        }
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <Form.Label className="font-semibold">
                      Variance Amount
                    </Form.Label>
                    <Form.Control
                      value={this.state.adjData.variance}
                      disabled={true}
                      placeholder="Enter amount"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <Form.Label className="font-semibold">
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.adjData.description}
                      onChange={(e) => {
                        this.setState((prevState) => ({
                          adjData: {
                            ...prevState.adjData,
                            description: e.target.value,
                          },
                        }));
                      }}
                      placeholder="Enter Description"
                    />
                  </div>
                </div>
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  this.setState({ showPopup1: false });
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={() => this.save()}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId,
});

export default connect(mapStateToProps)(BankSync);
